import { render, staticRenderFns } from "./jgmap.vue?vue&type=template&id=838822e8&scoped=true"
import script from "./jgmap.vue?vue&type=script&lang=js"
export * from "./jgmap.vue?vue&type=script&lang=js"
import style0 from "./jgmap.vue?vue&type=style&index=0&id=838822e8&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838822e8",
  null
  
)

export default component.exports